import { ResumeVehicle, FullRequestVehiclesHistory } from 'src/types'

export enum VehiclesActionTypes {
  GET_VEHICLES = '@vehicles/GET_VEHICLES',
  GET_VEHICLES_FAILURE = '@vehicles/GET_VEHICLES_FAILURE',
  GET_VEHICLES_HISTORY = '@vehicles/GET_VEHICLES_HISTORY',
  GET_VEHICLES_HISTORY_FAILURE = '@vehicles/GET_VEHICLES_HISTORY_FAILURE',
  GET_VEHICLES_HISTORY_SUCCESS = '@vehicles/GET_VEHICLES_HISTORY_SUCCESS',
  GET_VEHICLES_SUCCESS = '@vehicles/GET_VEHICLES_SUCCESS',
  RESET_VEHICLES = '@vehicles/RESET_VEHICLES'
}

export type VehiclesState = {
  readonly error: string
  readonly hasFinish: boolean
  readonly list: ResumeVehicle[]
  readonly loading: boolean
  readonly message_id: string[]
  readonly originalFullRequestVehiclesHistory: FullRequestVehiclesHistory
}
